export const benefitsData = [
  {
    id: 1,
    span: 'DESCUBRE',
    p: 'Encuentra el activo que calce mejor con tu perfil financiero',
  },
  {
    id: 2,
    span: 'SIMULA',
    p: 'Elige el activo inmobiliario que más te guste y simula tu inversión de manera personalizada para proceder con la reserva de la propiedad',
  },
  {
    id: 3,
    span: 'RELÁJATE',
    p: 'Gestionamos el crédito hipotecario, promesa de compra y escritura por ti',
  },
  {
    id: 4,
    span: 'GANA POR TU INVERSIÓN',
    p: 'Administramos el arriendo de tu propiedad para que comiences a ganar por tu inversión',
  },
];
